<template>
  <b-modal
    id="edit-team-modal"
    title="Edit Team"
    hide-footer
    @hidden="$emit('hidden')"
  >
    <b-form
      novalidate
      @submit.prevent="submitForm"
    >
      <validation-observer ref="formRef">
        <b-row>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name En"
              rules="required"
            >
              <b-form-group
                label="Name En"
                label-for="team-name-en"
              >
                <b-form-input
                  id="team-name-en"
                  v-model="formData.name.en"
                  placeholder="Name En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name Ar"
              rules="required"
            >
              <b-form-group
                label="Name Ar"
                label-for="team-name-ar"
              >
                <b-form-input
                  id="team-name-ar"
                  v-model="formData.name.ar"
                  placeholder="Name Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Description En"
            >
              <b-form-group
                label="Description En"
                label-for="team-description-en"
              >
                <b-form-textarea
                  id="team-description-en"
                  v-model="formData.description.en"
                  placeholder="description En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Description Ar"
            >
              <b-form-group
                label="Description Ar"
                label-for="team-description-ar"
              >
                <b-form-textarea
                  id="team-description-ar"
                  v-model="formData.description.ar"
                  placeholder="description Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <b-button
              type="submit"
              variant="primary"
              :disabled="submitting"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BRow,
  BFormTextarea,
  BCol,
  BModal,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref, watch } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormTextarea,
    BSpinner,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
  },
  props: {
    team: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)

    console.log(props.team)

    const formData = ref({
      name: {
        ar: null,
        en: null,
      },
      description: {
        ar: '',
        en: '',
      },
    })
    watch(() => props.team, () => {
      if (props.team) {
        formData.value.name.en = props.team.name.en
        formData.value.name.ar = props.team.name.ar
        formData.value.description.en = props.team?.description?.en || ''
        formData.value.description.ar = props.team?.description?.ar || ''
      }
    })

    const formRef = ref(null)

    const submitForm = async () => {
      const res = await formRef.value.validate()
      if (!res) return

      try {
        submitting.value = true
        await axiosIns.patch(`/teams/${props.team.id}`, formData.value)
        ctx.root.$bvModal.hide('edit-team-modal')
        ctx.emit('refetch')
      } catch (err) {
        errorNotification('An Error Occured')
      } finally {
        submitting.value = false
      }
    }

    return {
      submitting,
      formRef,
      submitForm,
      formData,
      required,
    }
  },
}
</script>

<style></style>
